import clsx from "clsx";

export function Badge({ tone = "default", children, ...rest }) {
  const map = {
    default: "bg-surface-hover text-ink",
    success: "bg-success-bg text-success border border-success-border",
    error: "bg-error-bg text-error border border-error-border",
    warning: "bg-warning-bg text-warning border border-warning-border",
    info: "bg-info-bg text-info border border-info-border",
    dryrun: "bg-dryrun-bg text-dryrun border border-dryrun-border",
  };
  return (
    <span {...rest} className={clsx("inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold", map[tone])}>
      {children}
    </span>
  );
}

export function Card({ className, children, ...rest }) {
  return (
    <div {...rest} className={clsx("bg-surface border border-border-default rounded-md shadow-card", className)}>
      {children}
    </div>
  );
}

export function Button({ variant = "primary", size = "md", className, children, ...rest }) {
  const sz = size === "sm" ? "h-8 px-3 text-xs" : "h-9 px-4 text-sm";
  const variants = {
    primary: "bg-primary text-primary-fg hover:bg-primary-hover",
    secondary: "bg-surface border border-border-default text-ink hover:bg-surface-hover",
    ghost: "bg-transparent text-ink hover:bg-surface-hover",
    danger: "bg-error text-white hover:opacity-90",
  };
  return (
    <button
      {...rest}
      className={clsx(
        "inline-flex items-center justify-center rounded-md font-medium tracking-tight transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
        sz, variants[variant], className
      )}
    >{children}</button>
  );
}

export function Input({ className, ...rest }) {
  return (
    <input
      {...rest}
      className={clsx(
        "w-full h-9 px-3 rounded-md border border-border-default bg-surface text-sm",
        "focus:outline-none focus:ring-2 focus:ring-ink focus:border-ink placeholder:text-ink-subtle",
        className
      )}
    />
  );
}

export function Label({ children, htmlFor, className }) {
  return (
    <label htmlFor={htmlFor} className={clsx("block text-sm font-medium mb-1.5 text-ink", className)}>
      {children}
    </label>
  );
}

export function Section({ title, subtitle, action, children, className }) {
  return (
    <section className={clsx("space-y-3", className)}>
      <header className="flex items-end justify-between gap-3">
        <div>
          <h2 className="font-display text-xl font-semibold tracking-tight">{title}</h2>
          {subtitle && <p className="text-sm text-ink-muted">{subtitle}</p>}
        </div>
        {action}
      </header>
      {children}
    </section>
  );
}

export function TH({ children }) {
  return <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wider text-ink-muted">{children}</th>;
}

export function TD({ children, className }) {
  return <td className={clsx("px-4 py-2.5 text-sm text-ink", className)}>{children}</td>;
}

export function Empty({ children }) {
  return <div className="px-4 py-10 text-center text-sm text-ink-muted">{children}</div>;
}
